// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Video from '/react4xp/components/Video'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// types
interface SingleVideoProps {
    title?: string
    video: {
        url: string
        playText: string
        videoType: 'youtube' | 'vimeo' | 'default'
        poster?: string
        posterMedium?: string
        cookieConsentHtml?: string
    }
}

export default function SingleVideo({
    title,
    video
}: SingleVideoProps) {
    return (
        <Section className='single-video'>
            <div className='container'>
                <div className={clsx(
                    'single-video__wrapper',
                    !title && 'single-video__wrapper--no-title'
                )}>

                    {isNonWhitespaceString(title) && (
                        <h2 className='h1-hero-small'>
                            {title}
                        </h2>
                    )}

                    <div className='video-outer-wrapper'>
                        <div className='shape-mask'>
                            <Video
                                video={{
                                    playText: video.playText,
                                    poster: video.poster, // 1200px x 680px
                                    posterMedium: video.posterMedium, // 700px x 400px
                                    videoType: video.videoType,
                                    url: video.url,
                                    cookieConsentHtml: video.cookieConsentHtml,
                                }}
                                className='cover'
                            />
                        </div>
                    </div>

                </div>
            </div>
        </Section>
    )
}